import { render, staticRenderFns } from "./FortuneWheelSetting.vue?vue&type=template&id=ad39024a"
import script from "./FortuneWheelSetting.vue?vue&type=script&lang=js"
export * from "./FortuneWheelSetting.vue?vue&type=script&lang=js"
import style0 from "./FortuneWheelSetting.vue?vue&type=style&index=0&id=ad39024a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports